module.exports = __webpack_public_path__ + "static/8-fb1fcf0d5d8816c4e9cd039e42587170.jpg";